import {
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_FAILURE,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_CLEANUP
} from '../constants';

export function reducer(state, action){

  let selectedTakingCarIndex
  let takingCarsPaginatedNew
  if(state.takingCarManagement?.currentTakingCar){
    const currentTakingCarRequestsId = state.takingCarManagement.currentTakingCar.requests_id
    selectedTakingCarIndex = state.takingCarManagement.takingCarsPaginated.findIndex(stock => stock.requests_id === currentTakingCarRequestsId)
  }

  switch(action.type){
    case STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_BEGIN:
      return {
        ...state,
        takingCarManagement:{
          ...state.takingCarManagement,
          deletePending: true,
          deleteSuccess: null,
          deleteError: null
        },
      }
    case STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_SUCCESS:
      takingCarsPaginatedNew = state.takingCarManagement.takingCarsPaginated
      takingCarsPaginatedNew[selectedTakingCarIndex].stock_state_name="No disponible"
      return {
        ...state,
        takingCarManagement:{
          ...state.takingCarManagement,
          currentTakingCar:{
            ...state.takingCarManagement.currentTakingCar,
            ...action.data,
            stock_state_name:"No disponible"
          },
          deletePending: false,
          deleteSuccess: true,
          deleteError: null,
          takingCarsPaginated: [
            ...takingCarsPaginatedNew
          ]
        },
      }
    case STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_FAILURE:
      return {
        ...state,
        takingCarManagement:{
          ...state.takingCarManagement,
          deletePending: false,
          deleteSuccess: false,
          deleteError: action.data
        }
      }
    case STOCK_TAKING_CAR_MANAGEMENT_DELETE_CLEANUP:
      return {
        ...state,
        takingCarManagement:{
          ...state.takingCarManagement,
          deletePending: null,
          deleteSuccess: null,
          deleteError: null
        }
      }
    default:
      return state
  }
}